import { useRouter } from 'next/router';
import { getItemListName } from '../utils/dataRouteFormat.js';

const useItemListName = (customRoute) => {
    const { route, query: { selectItemListName, slug }, } = useRouter();
    if (customRoute)
        return getItemListName(customRoute);
    const slugPath = Array.isArray(slug) ? slug.join('/') : slug;
    return selectItemListName || getItemListName(`${route}${slugPath}`);
};

export { useItemListName as default };
//# sourceMappingURL=useItemListName.js.map
